/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';

import SharpUp from '../../assets/icons/sharp_up.svg'
import SharpUpOne from '../../assets/icons/sharp_up_one.svg'
import SharpUpLock from '../../assets/icons/sharp_up_lock.svg'
import SharpDown from '../../assets/icons/sharp_down.svg'
import SharpDownOne from '../../assets/icons/sharp_down_one.svg'
import SharpDownLock from '../../assets/icons/sharp_down_lock.svg'
import DoubleUp from '../../assets/icons/double_up.svg'
import DoubleUpOne from '../../assets/icons/double_up_one.svg'
import DoubleUpLock from '../../assets/icons/double_up_lock.svg'
import DoubleDown from '../../assets/icons/double_down.svg'
import DoubleDownOne from '../../assets/icons/double_down_one.svg'
import DoubleDownLock from '../../assets/icons/double_down_lock.svg'
import Renote from '../../assets/icons/renote.svg'
import RenoteOne from '../../assets/icons/renote_one.svg'
import RenoteLock from '../../assets/icons/renote_lock.svg'
import SingleStaveHandler from "../../common/singleStaveHandler";


export interface SharpButtonProps {
    handler: SingleStaveHandler | null;
    isLianEr: boolean;
}

export const sharpIcons = {
    up: [SharpUp, SharpUpOne, SharpUpLock],
    down: [SharpDown, SharpDownOne, SharpDownLock],
    doubleUp: [DoubleUp, DoubleUpOne, DoubleUpLock],
    doubleDown: [DoubleDown, DoubleDownOne, DoubleDownLock],
    renote: [Renote, RenoteOne, RenoteLock],
};

const getSharpIndex = (num: number) => num % 3;
const SharpComponent = ({ value, onClick, icons }: { value: number; onClick: () => void; icons: any[] }) => {
    return (
        <button className="note" onClick={onClick}>
            <img src={icons[getSharpIndex(value)]} width={20} height={20} alt=""/>
        </button>
    );
};

export const SharpButtons = ({ handler, isLianEr }: SharpButtonProps) => {
    const [upValue, setUpValue] = useState(0);
    const [downValue, setDownValue] = useState(0);
    const [doubleDownValue, setDoubleDownValue] = useState(0);
    const [doubleUpValue, setDoubleUpValue] = useState(0);
    const [renoteValue, setRenoteValue] = useState(0);

    useEffect(() => {
        if (!handler) return;

        handler.setNoteUpStatus(upValue);

        if (upValue === 1) {
            handler.afterInsertNoteUpStatusCallback = () => {
                setUpValue(0);
            };
        } else {
            handler.afterInsertNoteUpStatusCallback = () => {
            };
        }
    }, [upValue]);

    useEffect(() => {
        if (!handler) return;

        handler.setNoteDownStatus(downValue);

        if (downValue === 1) {
            handler.afterInsertNoteDownStatusCallback = () => {
                setDownValue(0);
            };
        } else {
            handler.afterInsertNoteDownStatusCallback = () => {
            };
        }
    }, [downValue]);

    useEffect(() => {
        if (!handler) return;

        handler.setNoteDoubleUpStatus(doubleUpValue);

        if (doubleUpValue === 1) {
            handler.afterInsertNoteDoubleUpStatusCallback = () => {
                setDoubleUpValue(0);
            };
        } else {
            handler.afterInsertNoteDoubleUpStatusCallback = () => {
            };
        }
    }, [doubleUpValue]);

    useEffect(() => {
        if (!handler) return;

        handler.setNoteDoubleDownStatus(doubleDownValue);

        if (doubleDownValue === 1) {
            handler.afterInsertNoteDoubleDownStatusCallback = () => {
                setDoubleDownValue(0);
            };
        } else {
            handler.afterInsertNoteDoubleDownStatusCallback = () => {
            };
        }
    }, [doubleDownValue]);

    useEffect(() => {
        if (!handler) return;

        handler.setRenoteStatus(renoteValue);

        if (renoteValue === 1) {
            handler.afterInsertRenoteStatusCallback = () => {
                setRenoteValue(0);
            };
        } else {
            handler.afterInsertRenoteStatusCallback = () => {
            };
        }
    }, [renoteValue]);

    const clearVal = () => {
        setUpValue(0);
        setDownValue(0);
        setDoubleDownValue(0);
        setDoubleUpValue(0);
        setRenoteValue(0);
    }

    return (
        <React.Fragment>
            <SharpComponent
                value={upValue}
                onClick={() => {
                    clearVal();
                    setUpValue(getSharpIndex(upValue + 1));
                }}
                icons={sharpIcons.up}
            />
            <SharpComponent
                value={downValue}
                onClick={() => {
                    clearVal();
                    setDownValue(getSharpIndex(downValue + 1));
                }}
                icons={sharpIcons.down}
            />
            {!isLianEr &&
                <>
                    <SharpComponent
                        value={renoteValue}
                        onClick={() => {
                            clearVal();
                            setRenoteValue(getSharpIndex(renoteValue + 1));
                        }}
                        icons={sharpIcons.renote}
                    />
                    <SharpComponent
                        value={doubleUpValue}
                        onClick={() => {
                            clearVal();
                            setDoubleUpValue(getSharpIndex(doubleUpValue + 1));
                        }}
                        icons={sharpIcons.doubleUp}
                    />
                    <SharpComponent
                        value={doubleDownValue}
                        onClick={() => {
                            clearVal();
                            setDoubleDownValue(getSharpIndex(doubleDownValue + 1));
                        }}
                        icons={sharpIcons.doubleDown}
                    />
                </>}

        </React.Fragment>
    );
};
